import _ from 'lodash';
import { createSelector } from 'reselect';

const smartBoxCommercialIds = [  121,
                                122	,
                                127	,
                                128	,
                                174	,
                                183	,
                                186	,
                                187	,
                                191	,
                                195	,
                                197	,
                                198	,
                                200	,
                                201	,
                                202	];

export const smartBox2TechnicalIds = [ 110, 118 ];

export const isLoading = state => state.customer.profile.hardwareProducts.isLoading;

export const getHardwareProducts = state => state.customer.profile.hardwareProducts;
export const getHardwareProductList = state => state.customer.profile.hardwareProducts.productsList;
export const addHardwareFormData = state => state.customer.profile.hardwareProducts.addHardware;
export const addHardwareFormIsLoading = state => addHardwareFormData(state).isLoading;
export const addHardwareRequestSuccessful = state => addHardwareFormData(state).isSuccessful;

export const isHardwareSerialValid = state => state.customer.profile.hardwareProducts.addHardware.box.isValid;
export const isCardSerialValid = state => state.customer.profile.hardwareProducts.addHardware.card.isValid;
export const isBundledHardware = state => state.customer.profile.hardwareProducts.addHardware.isBundledHardware;
export const isMatchingHardwareEquipment = state => state.customer.profile.hardwareProducts.addHardware.box.isBundled === state.customer.profile.hardwareProducts.addHardware.card.isBundled;
export const hasBlockingError = data => !!(data.card.addHardwareInfo.isBlocked || data.box.addHardwareInfo.isBlocked);
export const addBoxForm = state => state.customer.profile.hardwareProducts.addHardware.box;
export const addCardForm = state => state.customer.profile.hardwareProducts.addHardware.card;

export const isAddHardwareFormStep3Valid = createSelector(
    addHardwareFormData,
    isCardSerialValid,
    isHardwareSerialValid,
    (data, cardValid, hardwareValid) => hardwareValid && cardValid && (data.cardList.length > 0 || data.hardwareList.length > 0)
    );


export const isAddHardwareFormStep1Valid = createSelector(
    addHardwareFormIsLoading,
    addHardwareFormData,
    isHardwareSerialValid,
    isCardSerialValid,
    isMatchingHardwareEquipment,
    (addHardwareFormIsLoading, data, isHardwareValid, isCardValid, isMatchingHardware) => {
        if (addHardwareFormIsLoading || data.card.isLoading || data.box.isLoading) {
            return false;
        }
        if (hasBlockingError(data)) {
            return false;
        }
        if (!data.card.serialNumber && !data.box.serialNumber) {
            return false;
        }
        if(!isMatchingHardware)
            return false;
        if (data.isBundledHardware) {
            return data.box.list.length > 0 && data.card.list.length > 0 && isHardwareValid;
        }
        else {
            return isHardwareValid && isCardValid && !data.card.notEligibleToMove;
        }
    }
);

export const isAddHardwareFormStep2Valid = createSelector(
    addHardwareFormData,
    isCardSerialValid,
    isHardwareSerialValid,
    (data, isHardwareValid, isCardValid) => {
        if (hasBlockingError(data)) {
            return false;
        }
        let listIsNotEmpty = (data.card.list.length > 0 || data.box.list.length > 0);
        return isHardwareValid && isCardValid && listIsNotEmpty;
    }
);

export const isHardwareProductsToCancelSelected = createSelector(
    getHardwareProducts,
    data => data.productsList.some(x => x.isToCancel === true));


export const hasSmartBoxProduct = createSelector(
    getHardwareProducts,
    products => products.productsList.some(x => _.includes(smartBoxCommercialIds, x.commercialId)));



// SERIAL MANAGEMENT
export const getGroupedProducts = (state) => {
    let groups = [];
    for (let product of getHardwareProductList(state)) {
        const id = product.commercialProductAgreementDetailId;
        if (!groups.find(group => group.id === id)) {
            groups.push({ id, products: [] });
        }
        groups.find(group => group.id === id).products.push(product);
    }
    return groups;
}

export const getSerialsForAgreementDetailsId = (state, agreementDetailsId) => state.customer.profile.hardwareProducts.serials[agreementDetailsId] || {};
export const getHardwareDetails = (state, agreementDetailsId) => {
    let details = [];
    const serials = getSerialsForAgreementDetailsId(state, agreementDetailsId);
    for (let i in serials) {
        details.push({ SerialNumber: serials[i], ProductType: 3 });
    }
    return details;
}
export const getCurrentSerial = (state, agreementDetailsId, key) => getSerialsForAgreementDetailsId(state, agreementDetailsId)[key];

// Search
export const getSearchData = (state, serial) => state.customer.profile.hardwareProducts.search[serial] || {};
export const getSearchStatus = (state, serial) => getSearchData(state, serial).status;
export const getSearchResult = (state, serial) => getSearchData(state, serial).result;
export const isSearchLoading = (state, serial) => getSearchStatus(state, serial) === 'loading';
export const isSearchLoaded = (state, serial) => getSearchStatus(state, serial) === 'loaded';
export const isSearchFailed = (state, serial) => getSearchStatus(state, serial) === 'failed';

export const isSaving = (state) => state.customer.profile.hardwareProducts.saving === true;